var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHrv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 512,
    height: 341.326,
    y: 85.337
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 512,
    height: 113.775,
    y: 85.337
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052b4"
    },
    width: 512,
    height: 113.775,
    y: 312.888
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338af3"
    },
    points: "300.522 204.059 270.84 204.059 275.788 166.957 295.575 152.116 315.362 166.957 315.362 196.638"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338af3"
    },
    points: "211.478 204.059 241.16 204.059 236.212 166.957 216.425 152.116 196.638 166.957 196.638 196.638"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052b4"
    },
    points: "275.788 204.059 236.212 204.059 236.212 166.957 256 152.116 275.788 166.957"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "M196.638,196.638v81.623c0,19.436,9.389,36.719,23.868,47.555l10.388-2.6l13.109,13.188 c3.876,0.798,7.887,1.219,11.996,1.219c4.087,0,8.077-0.415,11.934-1.205l14.964-12.459l8.595,1.834 c14.474-10.834,23.868-28.101,23.868-47.531v-81.623L196.638,196.638L196.638,196.638z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 23.745,
    height: 23.745,
    x: 196.641,
    y: 196.641
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 23.745,
    height: 23.745,
    x: 244.124,
    y: 196.641
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 23.745,
    height: 23.745,
    x: 291.617,
    y: 196.641
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 23.745,
    height: 23.745,
    x: 220.383,
    y: 220.383
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 23.745,
    height: 23.745,
    x: 267.876,
    y: 220.383
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 23.745,
    height: 23.745,
    x: 196.641,
    y: 244.124
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 23.745,
    height: 23.745,
    x: 220.383,
    y: 267.865
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 23.745,
    height: 23.745,
    x: 244.124,
    y: 244.124
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 23.745,
    height: 23.745,
    x: 291.617,
    y: 244.124
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 23.745,
    height: 23.745,
    x: 267.876,
    y: 267.865
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 23.745,
    height: 23.745,
    x: 244.124,
    y: 291.617
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80027"
    },
    d: "M220.383,291.613h-22.212c2.038,8.826,6.042,16.904,11.536,23.745h10.676V291.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80027"
    },
    d: "M291.617,315.357h10.677c5.493-6.842,9.498-14.919,11.536-23.745h-22.213V315.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80027"
    },
    d: "M220.383,315.357v10.361c6.906,5.196,14.976,8.923,23.745,10.71v-21.071H220.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80027"
    },
    d: "M267.873,315.357v21.071c8.769-1.786,16.839-5.514,23.745-10.71v-10.361H267.873z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrv);
export default __webpack_public_path__ + "static/media/hrv.561f5a06d1191c6e1684561ef5b7fe7b.svg";
export { ForwardRef as ReactComponent };